import type { IRecordTypeDefinition } from '@platform/core/types';
import { editorTabs, isKb, keyToggles, tagsKeyOf, visibleFields } from './formRules';
import { autoWidthOf } from './formWidths';
import type { IFormPreview } from './IFormPreview';
import type { IProtoForm } from './IProtoForm';

/**
 * Перегляд форми за моделлю редактора (прототип v4 fp*): статус, пріоритет і термін ключового рядка (у базі знань — лише статус),
 * «Загальне» й увімкнені вкладки, теги й опис під назвою, групи з полями (виконавець — теж) і шириною поля без подвоєння «Подробиць»;
 * порожні групи не показуються. Чиста функція.
 */
export function formPreviewOf(rt: IRecordTypeDefinition, form: IProtoForm, published?: IRecordTypeDefinition): IFormPreview {
  const fields = visibleFields(rt);
  const byKey = new Map(fields.map((f) => [f.key, f]));
  const kb = isKb(rt);
  return {
    keys: keyToggles.filter((k) => byKey.has(k) && form.key[k] && !(kb && k !== 'status')),
    tabs: ['general', ...editorTabs.filter((t) => form.tabs[t])],
    tags: !!tagsKeyOf(fields) && form.showTags,
    description: !kb && form.showDesc && byKey.has('description'),
    groups: form.groups.map((g) => ({
      id: g.id, title: g.title,
      fields: g.keys.filter((k) => byKey.has(k)).map((key) => ({ key, width: form.widths[key] ?? autoWidthOf(byKey.get(key)!, published) })),
    })).filter((g) => g.fields.length > 0),
  };
}
